import Hero from "../components/hero";
import ProjectSuccess from "../components/projectsuccess";
import React from "react";

function Home() {
    return (<section
        className="h-screen flex flex-col justify-between p-8 pt-20 bg-cover bg-center relative overflow-hidden"
        style={{
            position: "relative", overflow: "hidden",
        }}
    >
        <div
            className="absolute inset-0 z-0 bg-homeCover"
            style={{
                backgroundImage: `url("../images/homeCover.jpg")`
            }}
        />

        <div className="absolute inset-0 bg-black/10 z-0"/>

        <div className="relative z-10 h-full flex flex-col">
            <Hero/>
            <ProjectSuccess/>
        </div>
    </section>);
}

export default Home;
